// extracted by mini-css-extract-plugin
export default {"flyoverCancel":"FlyoverCancel--flyoverCancel--Ao6X0"};